import { Box, Tabs, Tab, Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import StoreOrders from "./storeOrders";
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Bar, Tooltip } from "recharts";
import FileDownloadIcon from '@mui/icons-material/FileDownload';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type DayOfWeek =
  | "Monday"
  | "Tuesday"
  | "Wednesday"
  | "Thursday"
  | "Friday"
  | "Saturday"
  | "Sunday";

interface Availability {
  enabled: boolean;
  start: string;
  end: string;
}

const dauData = [
  { name: "Mon", users: 120 },
  { name: "Tue", users: 210 },
  { name: "Wed", users: 180 },
  { name: "Thu", users: 300 },
  { name: "Fri", users: 260 },
  { name: "Sat", users: 140 },
  { name: "Sun", users: 170 },
];

const StoreDetail = () => {

  const navigate = useNavigate();
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [availability] = useState<Record<DayOfWeek, Availability>>({
    Monday: { enabled: true, start: "09:00", end: "18:00" },
    Tuesday: { enabled: true, start: "10:00", end: "17:00" },
    Wednesday: { enabled: false, start: "09:00", end: "18:00" },
    Thursday: { enabled: true, start: "09:00", end: "18:00" },
    Friday: { enabled: true, start: "09:00", end: "20:00" },
    Saturday: { enabled: false, start: "09:00", end: "18:00" },
    Sunday: { enabled: false, start: "09:00", end: "18:00" },
  });

  return (
    <>
      <div className="main_title">
        <h1>#ST001 - Store Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - {" "}
          <button onClick={() => navigate("/manage-stores")}>Store Management</button> -
          Store Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Store Info" {...a11yProps(0)} />
              <Tab label="Store Availability" {...a11yProps(1)} />
              <Tab label="Orders" {...a11yProps(2)} />
              <Tab label="Revenue" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="gap_p">
            <div className="vew_img v2 no_radius w_100">
              <h6>Store Image</h6>
              <figure>
                <img alt="user" src="/static/images/placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Store Code</h6>
              <p>#ST001</p>
            </div>
            <div className="w_33">
              <h6>Store Name</h6>
              <p>Downtown Store</p>
            </div>
            <div className="w_33">
              <h6>Store Manager Contact</h6>
              <p>+919876543110</p>
            </div>
            <div className="w_100">
              <h6>Address</h6>
              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias, aspernatur.</p>
            </div>
            <div className="w_33">
              <h6>Region / City</h6>
              <p>New York</p>
            </div>
            <div className="w_33">
              <h6>Status</h6>
              <p className="c_success">Open</p>
            </div>
            <div className="w_33">
              <h6>Created Date</h6>
              <p>01-Sept-2025</p>
            </div>
            <div className="w_100">
              <h6>Flavours</h6>
              <p>Strawberry, Vanilla</p>
            </div>
            <div className="w_100">
              <h6>Topping</h6>
              <p>Chocolate Chips, Kiwi, Blackberries</p>
            </div>
            <div className="w_100">
              <h6>Products</h6>
              <p>GoGreek Cino, Espresso</p>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="gap_p">
            <div className="w_100">
              <h6>Weekly Availability</h6>
              <ul className="availability_list">
                {(Object.keys(availability) as DayOfWeek[]).map((day) =>
                  availability[day].enabled ? (
                    <li key={day}>
                      <strong>{day}:</strong> {availability[day].start} - {availability[day].end}
                    </li>
                  ) : null
                )}
              </ul>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <StoreOrders />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>


          <div className="stats_boxes gap_m">
            <div className="cards">
              <figure>
                <img src="/static/images/order.svg" alt="Revenue" />
              </figure>
              <h2>200</h2>
              <p>Total Order</p>
            </div>
            <div className="cards">
              <figure>
                <img src="/static/images/user_icon.svg" alt="Users" />
              </figure>
              <h2>$800</h2>
              <p>Today Earning</p>
            </div>
            <div className="cards">
              <figure>
                <img src="/static/images/user_icon.svg" alt="Active Users" />
              </figure>
              <h2>$5000</h2>
              <p>Total Earning</p>
            </div>
          </div>

          <div className="grid_sc gap_m">
            <div className="cards table_card">
              <div className="cards_header">
                <div className="left_s">
                  <h2>Total Revenue</h2>
                </div>
                <div className="right_s">
                  <p>
                    <span>A day</span>
                    <span>A week</span>
                    <span>A month</span>
                    <span>A year</span>
                  </p>
                  <Button className="btn btn_black icon_btn"><FileDownloadIcon /> </Button>
                </div>
              </div>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={dauData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="users" fill="#38B6FF" />
                </BarChart>
              </ResponsiveContainer>
            </div>

          </div>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default StoreDetail;
